import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.css']
})
export class RewardsComponent implements OnInit {
  @ViewChild('reviews') rewards: ElementRef;
  items = [
    {
      fullText: 'rewards1',
      authorData: '',
      img: ''
    },
    {
      fullText: 'rewards2',
      authorData: '',
      img: '',
      link: ''
    }
  ];

  constructor(
    private sanitaizer: DomSanitizer
  ) {
  }

  ngOnInit(): void {
  }

  getHtml(str: string): any {
    return this.sanitaizer.bypassSecurityTrustHtml(str);
  }

}
